import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const radioCardStyles = {
  field: css({
    '> div': {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
      gap: theme.spacing(2),
    },
  }),
  radioOption: css({
    minHeight: 72,
    alignItems: 'center',
    transition: 'background 0.4s ease-in-out',
  }),
  expandedRadioOption: css({
    div: { pointerEvents: 'unset' },
    gridColumn: '1 / -1', // Span full width across all columns
    alignItems: 'flex-start',
  }),
  input: css({
    backgroundColor: theme.colors.white,
    marginTop: theme.spacing(0.5),
  }),
};
